import { defineMessages } from 'react-intl';

export default defineMessages({
    documentSummaryTabs: {
        id: 'document.document-summary-page.Documents Summary',
        defaultMessage: 'Documents Summary'
    },
    failedToLoadPolices: {
        id: 'document.document-summary.Failed to load polices',
        defaultMessage: 'Failed to load polices'
    },
    sorryWeCanNotLoadYourPolicyInformationAtThisTime: {
        id: 'document.document-summary.Sorry we can not load your policy information at this time',
        defaultMessage: 'Sorry we can not load your policy information at this time'
    },
    noDocumentData: {
        id: 'document.document-summary.no document data',
        defaultMessage: 'No Document Data Available at this time'
    }
});
